import { defineMessage, useIntl } from "react-intl";

import { useProductData, type Product } from "../../product-subnav";

import { ProductsGrid } from "./products-grid";

const title = defineMessage({
    id: "globalnav.v2.products.featured.recommendations",
    defaultMessage: "Recommended based on your existing Atlassian apps"
});

type ProductRecommendationsContainerProps = {
    recommendedProductIds: string[];
    isMobile: boolean;
    customTitle?: string;
};

export const ProductRecommendationsContainer = ({
    recommendedProductIds,
    isMobile,
    customTitle
}: ProductRecommendationsContainerProps) => {
    const intl = useIntl();
    const { products } = useProductData();

    if (recommendedProductIds.length === 0) {
        return null;
    }

    const productsToRender: Product[] = recommendedProductIds
        .map((id) => products[id as keyof typeof products])
        .filter((product): product is Product => product !== undefined);

    return (
        <ProductsGrid
            products={productsToRender}
            title={customTitle ? customTitle : intl.formatMessage(title)}
            isMobile={isMobile}
            container={"ProductsRecommendationsContainer"}
        />
    );
};
